import { triggerPageView } from '../analytics/analytics';
import { toggleError } from './form';
import { isEmail } from './_utils';
import { disableLoadingIndicator, enableLoadingIndicator } from './loadingIndicator';

export default function subscriptions(config) {
	config = $.extend(
		{},
		{
			fieldsFilter: () => true,
			errorMsg: '.Subscription-error',
			formSelector: '.SubscriptionForm',
			submitSelector: '.SubscriptionSubmit',
			thanksSelector: '.SubscriptionThanks',
			bodySelector: '',
			legalAgreement: false,
			userInfo: false,
			subscriptionChoices: false,
			skipAllSubscriptionChoicesTrue: false,
			onlyOneLegalRequired: false,
		},
		config || {}
	);

	let subscriptionResult = {};

	const body = $(config.bodySelector);
	const form = body.find(config.formSelector);
	const thanks = body.find(config.thanksSelector);
	const submitButton = body.find(config.submitSelector);
	const errorMsg = $(config.errorMsg);
	if (body.length && form.length) {
		var verifyRecaptcha = window.FS.recaptcha.addRecaptcha(form[0]);

		let qualtricsIntercept;
		if (config.UNSUBSCRIBE_SURVEY_INTERCEPT_ID) {
			// window?.FS?.Qualtrics?.hasInterceptPassed(config.UNSUBSCRIBE_SURVEY_INTERCEPT_ID, false)
			window?.FS?.Qualtrics?.hasInterceptPassed(config.UNSUBSCRIBE_SURVEY_INTERCEPT_ID)
				.then(intercept => {
					if (intercept.passed) {
						qualtricsIntercept = intercept;
					}
				})
				.catch(e => {
					console.error('faild to get unsubscribe survey', e);
				});
		}

		//handle the submit
		form.submit(function (e) {
			//serialize form
			function getFormData() {
				let formFields = form.serializeArray();

				if (!config.subscriptionChoices && !config.skipAllSubscriptionChoicesTrue) {
					const allSubscriptionChoicesTrue = [{ name: 'all', value: 'true' }];
					formFields = formFields.concat(allSubscriptionChoicesTrue);
				}

				const subscriptionNames = subscriptionResult.subscriptionChoices
					? subscriptionResult.subscriptionChoices.toArray().map(x => x.name)
					: [];

				return formFields.filter(config.fieldsFilter).reduce((result, item) => {
					if (subscriptionNames.includes(item.name)) {
						if (!result.subscriptions) {
							result.subscriptions = {};
						}
						result.subscriptions[item.name] = item.value;
					} else {
						result[item.name] = item.value;
					}
					return result;
				}, {});
			}

			//Submit form
			function submitForm() {
				enableLoadingIndicator();
				const formData = getFormData();

				$.ajax({
					type: 'POST',
					url: form.attr('action'),
					crossDomain: true,
					dataType: 'json',
					data: formData,
					success: function (response) {
						if (response && response.success) {
							triggerPageView({ event_name: 'form_submit' });
							toggleError(errorMsg, 'off', 0);
							if (form.data('submission-redirect')) {
								setTimeout(
									function (url) {
										window.location = url;
										disableLoadingIndicator();
									},
									250,
									form.data('submission-redirect')
								);
							} else {
								disableLoadingIndicator();
								form.slideUp();
								thanks.slideDown();
								body.find('.SubscriptionContainer').addClass(
									'SubscriptionThanksShowing'
								);
								if (qualtricsIntercept) {
									body.find('.SubscriptionUnsubscribeSurveyContainer').show();
									qualtricsIntercept.runIntercept();
								}
							}
						} else {
							disableLoadingIndicator();
							toggleError(errorMsg, 'on', 0);
							window.FS.recaptcha.reset(form[0]);
						}
						$('html, body').animate({
							scrollTop: body.offset().top - 170,
						});
					},
					error: function (resonse) {
						disableLoadingIndicator();
						toggleError(errorMsg, 'on', 0);
						window.FS.recaptcha.reset(form[0]);
						$('html, body').animate({
							scrollTop: body.offset().top - 170,
						});
					},
				});
			}
			e.preventDefault();
			verifyRecaptcha(submitForm, function (error) {
				toggleError(errorMsg, 'on', 0);
				window.FS.recaptcha.reset(form[0]);
				const formData = getFormData();
				const context = {
					email: isEmail(formData.email)
						? formData.email.replace(
								formData.email.substring(1, formData.email.lastIndexOf('@')),
								'****'
						  )
						: 'not provided',
					unsubscribe: form.attr('action').includes('Unsubscribe'),
					choices: formData.subscriptions || {},
				};

				if (elasticApm && elasticApm.isEnabled()) {
					elasticApm.setCustomContext(context);
					elasticApm.captureError(
						`Subscription Form could not be submitted: ${error || 'Recaptcha Failed'}`
					);
					elasticApm.setCustomContext({});
				}
			});
		});
	}

	//function to update submit status
	let updateSubmit = function () {
		let validationCriteria = [];
		if (config.subscriptionChoices) {
			validationCriteria.push(() => {
				let valid = false;
				//need at least one subscription option selected
				subscriptionResult.subscriptionChoices.each(function () {
					if ($(this).is(':checked')) {
						valid = true;
					}
				});
				return valid;
			});
		}

		if (config.legalAgreement) {
			validationCriteria.push(() => {
				let valid = true;
				let oneChecked = false;
				subscriptionResult.legalAgreementCheckboxes.each(function () {
					if ($(this).is(':checked')) {
						oneChecked = true;
					} else {
						valid = false;
					}
				});
				return valid || (config.onlyOneLegalRequired && oneChecked);
			});
		}

		if (config.userInfo) {
			validationCriteria.push(() => {
				let valid = false;
				subscriptionResult.userInfoTextInputs.each(function (index, element) {
					const value = $(this).val();
					valid = value.length ? true : false;

					// Pattern validation
					if (valid && $(this).attr('pattern')) {
						const pattern = $(this).attr('pattern');
						const fieldRegExp = new RegExp(pattern);
						valid = fieldRegExp.test(value);
					}

					// Email validation
					if (valid && $(this).attr('type') === 'email') {
						valid = isEmail(value);
					}

					return valid;
				});

				if (valid) {
					subscriptionResult.userInfoSelectInputs.each(function () {
						const value = $(this).val();
						valid = value && value.length ? true : false;
						return valid;
					});
				}

				return valid;
			});
		}

		//Check for loaded recaptcha before allowing submit
		validationCriteria.push(() => {
			return window.FS.recaptcha.isLoaded;
		});

		//we can enable submit if there are criteria and all the criteria are true.
		//that is checked by filtering the array using the criteria function itself
		//verifying that the lengths are still the same
		let enableSubmit =
			validationCriteria.length &&
			validationCriteria.filter(criteria => criteria()).length === validationCriteria.length;

		if (enableSubmit) {
			submitButton.attr('disabled', false);
		} else {
			submitButton.attr('disabled', true);
		}
	};

	//setup listeners based on what this form uses
	$(window).on('recaptchaIsLoaded', updateSubmit);

	if (config.subscriptionChoices) {
		subscriptionResult.subscriptionChoices = body
			.find('.SubscriptionChoices .Checkbox-input')
			.not('#all');
		subscriptionResult.allChoicesCheckbox = body.find('.SubscriptionChoices #all');

		subscriptionResult.subscriptionChoices.on('change', function (e) {
			if ($(this).not(':checked')) {
				subscriptionResult.allChoicesCheckbox.prop('checked', false);
			}
			updateSubmit();
		});

		subscriptionResult.allChoicesCheckbox.on('change', function () {
			if (subscriptionResult.allChoicesCheckbox.is(':checked')) {
				subscriptionResult.subscriptionChoices.prop('checked', true);
			}
			updateSubmit();
		});
	}

	if (config.legalAgreement) {
		subscriptionResult.legalAgreementCheckboxes = body.find('.LegalAgreement .Checkbox-input');
		subscriptionResult.legalAgreementCheckboxes.on('change', updateSubmit);
	}

	if (config.userInfo) {
		subscriptionResult.userInfoTextInputs = body.find('.UserInfo .TextInput-field');
		subscriptionResult.userInfoSelectInputs = body.find('.UserInfo .Dropdown-field');

		//handle enabling the submit and adding the filled class
		let addFilledClass = function (e) {
			const curInput = $(this);
			let hasValue = curInput.val().length ? true : false;
			if (hasValue) {
				curInput.addClass('formElement-field--filled');
			} else {
				curInput.removeClass('formElement-field--filled');
			}

			updateSubmit();
		};

		subscriptionResult.userInfoTextInputs.on('keyup', addFilledClass);
		subscriptionResult.userInfoSelectInputs.on('change', addFilledClass);
	}

	subscriptionResult.formExists = () => {
		return body.length && form.length;
	};

	subscriptionResult.redirectPage = () => {
		if (body.hasClass('publish')) {
			//redirect to the subscribe page
			window.location =
				form.data('redirect-page') || 'https://www.fourseasons.com/email-sign-up/';
		}
	};

	return subscriptionResult;
}
